<div class="ngx-mat-tel-input-container">
  <button [matMenuTriggerFor]="menu" [disabled]="disabled" type="button" mat-button class="country-selector">
    @if (selectedCountry()?.flagClass; as flagClass) {
      <span [class]="'country-selector-flag flag ' + flagClass"></span>
    }
    @if (selectedCountry()?.dialCode; as dialCode) {
      <span class="country-selector-code">+{{ dialCode }}</span>
    }
  </button>

  <mat-menu
    #menu="matMenu"
    class="ngx-mat-tel-input-mat-menu-panel"
    backdropClass="ngx-mat-tel-input-overlay-backdrop"
    overlayPanelClass="ngx-mat-tel-input-overlay-pane"
  >
    @if (enableSearch()) {
      <input
        [placeholder]="searchPlaceholder()"
        [attr.aria-label]="searchPlaceholder() || 'Rechercher un pays'"
        [ngModel]="searchCriteria()"
        (ngModelChange)="searchCriteria.set($event)"
        (click)="$event.stopPropagation()"
        class="country-search"
        type="text"
      />
    }

    @if (!searchCriteria()) {
      @for (country of preferredCountriesInDropDown(); track country.iso2) {
        <button (click)="onCountrySelect(country)" type="button" mat-menu-item class="country-list-button">
          <div class="icon-wrapper">
            <div [class]="'flag ' + country.flagClass"></div>
          </div>
          <div class="label-wrapper">
            {{ country.name }}
            @if (country.dialCode) {
              <span>+{{ country.dialCode }}</span>
            }
          </div>
        </button>
      }

      @if (preferredCountriesInDropDown().length > 0) {
        <mat-divider></mat-divider>
      }
    }

    @for (country of filteredCountries(); track country.iso2) {
      <button (click)="onCountrySelect(country)" type="button" mat-menu-item class="country-list-button">
        <div class="icon-wrapper">
          <div [class]="'flag ' + country.flagClass"></div>
        </div>
        <div class="label-wrapper">{{ country.name }} +{{ country.dialCode }}</div>
      </button>
    }
  </mat-menu>

  <input
    [class]="cssClass() || ''"
    [errorStateMatcher]="errorStateMatcher() || defaultErrorStateMatcher"
    [placeholder]="inputPlaceholder() || placeholder"
    [attr.aria-label]="inputPlaceholder() || placeholder || 'Numéro de téléphone'"
    [disabled]="disabled"
    [aria-describedby]="ariaDescribedBy()"
    [ngModel]="phoneNumber()"
    (blur)="onTouched()"
    (keypress)="onInputKeyPress($event)"
    (ngModelChange)="onInputModelChange($event)"
    matInput
    type="tel"
    autocomplete="tel"
    #focusable
  />
</div>
